export default __webpack_public_path__ + "static/footer-logo-6edc523a5df74ac71c5b31efebf24257.png";